<template>
    <a-card :bordered="false" class="team-management-panel">
        <div slot="title">
            班组管理
            <a-tag :color="cornerMarkConfig.color">
                {{ cornerMarkConfig.title }}
            </a-tag>
        </div>
        <div class="team-management-panel__scroll">
            <!-- 单位列表 -->
            <unit-panel
                :read-only="!!readOnly"
                :project-code="projectCode"
                :team-portal-target="teamPortalTarget"
                :personnel-portal-target="personnelPortalTarget"
                @update="handleUpdate"
            />

            <!-- 班组列表 -->
            <custom-portal-target :name="teamPortalTarget" :slim="true" />

            <!-- 班组详情 -->
            <custom-portal-target :name="personnelPortalTarget" :slim="true" />
        </div>
    </a-card>
</template>
<script>
import { Card as ACard, Tag as ATag } from 'ant-design-vue'
import CustomPortalTarget from '@components/CustomPortalVue/PortalTarget'

import UnitPanel from './UnitPanel'

import './style.scss'

import getProjectModuleCompleteness from '@service/project/getProjectModuleCompleteness'

import { PROJECT_INFO_MODULE_NAME_TEAM_MANAGEMENT } from '@constant/enum'

export default {
    name: 'TeamManagementPanel',
    components: {
        ACard,
        ATag,
        UnitPanel,
        CustomPortalTarget
    },
    props: {
        readOnly: [Boolean, Number]
    },
    data() {
        const generatePortalTarget = name => `${this._uid}_${name}`

        return {
            teamPortalTarget: generatePortalTarget('teamPanel'),
            personnelPortalTarget: generatePortalTarget('personnelPanel'),
            cornerMarkConfig: {}
        }
    },
    computed: {
        projectCode() {
            return this.$route.query.projectCode
        }
    },
    watch: {
        projectCode: {
            handler(val) {
                val && this.getCornerMark()
            },
            immediate: true
        }
    },
    methods: {
        // 获取角标数据
        async getCornerMark() {
            try {
                const result = await getProjectModuleCompleteness({
                    projectCode: this.projectCode,
                    moduleCode: PROJECT_INFO_MODULE_NAME_TEAM_MANAGEMENT
                })
                result.finalCnf ? this.cornerMarkConfig = {
                    title: '已完善',
                    color: 'green'
                } : this.cornerMarkConfig = {
                    title: '未完善',
                    color: 'orange'
                }
            } catch (error) {
                this.$message.warning(error.message)
            }
        },
        handleUpdate() {
            this.getCornerMark()
        }
    }
}
</script>

<style lang="scss">
.team-management-panel {
    .ant-tag {
        position: relative;
        top: -2px;
        left: 4px;
    }
}
</style>
